
export default {
  props: {},
  data () {
    return {
      Accordion: {
        count: 0,
        active: []
      }
    }
  },
  provide () {
    return { Accordion: this.Accordion }
  }
}
